<template>
  <div class="general">
    <div class="banner">
      <img src="@/assets/images/generalJune/banner_new.jpg" alt="" />
    </div>
    <!-- <div class="title">
        <img src="@/assets/images/general/title.png" alt="" />
      </div> -->
    <div class="title">数字教材</div>
    <div class="container nopadding">
      <div class="book_list">
        <div
          class="book_item"
          v-for="(item, index) in bookList"
          :key="index"
          @click="toDetail(item.url)"
        >
          <div class="white">
            <div class="shadow">
              <div class="whites">
                <div
                  class="title_pic"
                  :style="{
                    background: `url(${item.cover})`,
                    backgroundSize: `100% 100%`,
                  }"
                ></div>
              </div>
            </div>
          </div>

          <div class="text">
            <div>主编：{{ item.editor }}</div>
            <div>简介：</div>
            <div class="introduce">
              {{ item.text }}
            </div>
          </div>
          <div class="back"></div>
        </div>
      </div>
    </div>

    <!-- <div class="title">数字经济教材</div>
      <div class="container">
        <div class="book_list">
          <div
            class="book_item"
            v-for="(item, index) in bookList"
            :key="index"
            @click="toDetail(item.url)"
          >
            <div class="white">
              <div class="shadow">
                <div class="whites">
                  <div
                    class="title_pic"
                    :style="{
                      background: `url(${item.cover})`,
                      backgroundSize: `100% 100%`,
                    }"
                  ></div>
                </div>
              </div>
            </div>
  
            <div class="text">
              <div>主编：{{ item.editor }}</div>
              <div>简介：</div>
              <div class="introduce">
                {{ item.text }}
              </div>
            </div>
            <div class="back"></div>
          </div>
        </div>
      </div> -->
  </div>
</template>
    
    <script>
import cover1 from "../../assets/images/generalJune/back1.png";
import cover2 from "../../assets/images/generalJune/back2.png";
import cover3 from "../../assets/images/generalJune/back3.png";
import cover4 from "../../assets/images/generalJune/back4.png";
import cover5 from "../../assets/images/generalJune/back5.png";
import cover6 from "../../assets/images/generalJune/back6.png";
import cover7 from "../../assets/images/generalJune/back7.png";
import cover8 from "../../assets/images/generalJune/back8.png";

//   import new1 from "../../assets/images/general/new1.png";
//   import new2 from "../../assets/images/general/new2.png";
//   import new3 from "../../assets/images/general/new3.png";
//   import new4 from "../../assets/images/general/new4.png";
//   import new5 from "../../assets/images/general/new17.png";
//   import new6 from "../../assets/images/general/new6.png";
//   import new7 from "../../assets/images/general/new7.png";
//   import new8 from "../../assets/images/general/new8.png";
//   import new9 from "../../assets/images/general/new9.png";
//   import new10 from "../../assets/images/general/new10.png";
//   import new11 from "../../assets/images/general/new11.png";
//   import new12 from "../../assets/images/general/new12.png";
//   import new13 from "../../assets/images/general/new13.png";
//   import new14 from "../../assets/images/general/new14.png";
//   import new15 from "../../assets/images/general/new15.png";
//   import new16 from "../../assets/images/general/new16.png";

export default {
  data() {
    return {
      bookList: [
        {
          editor: " ",
          cover: cover1,
          text: "增值税作为一种在全球广泛应用的流转税，具有独特的计税原理与重要意义。其核心在于对商品和服务在流转过程中的增值额进行征税，通过销项税额减去进项税额的计算方式，有效避免了传统流转税的重复征税问题。这一特性使得各生产经营环节的税负更为合理公平，极大地促进了企业间的公平竞争，为市场经济的健康有序发展提供了有力保障。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927601902279856128&goodsType=looseleafOrtextbook",
        },
        {
          editor: "",
          cover: cover2,
          text: "大学是我们人生的黄金阶段、是进入职场的第一个门槛，也是一生幸福的敲门砖。我们应该正确认识到，在这个阶段，培养职业能力和素养固然重要，但是健康是成为优秀职业人的前提。《关于加强学生心理健康管理工作的通知》要求进一步提高学生心理健康工作的针对性和有效性，切实加强专业支撑和科学管理，着力提升学生心理健康素养。了解心理健康知识，学会识别心理健康问题，并掌握保持健康心理状态的方法，这样才能更好地适应学习和生活，并在将来更好地适应社会。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927603069021982720&goodsType=looseleafOrtextbook",
        },
        {
          editor: "",
          cover: cover3,
          text: "物流信息（Logistics Information）是指反映物流各种活动内容的知识、资料、图像、数据、文件的总称。 从狭义范围来看，物流信息是指与物流活动（如运输、保管、包装、流通加工等）有关的信息。物流信息对运输管理、库存管理、订单管理等物流活动具有支持保证的功能。 从广义范围来看，物流信息不仅指与物流活动有关的信息，而且包含与其他流通活动有关的信息，如商品交易信息和市场信息等。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927603500800413696&goodsType=looseleafOrtextbook",
        },
        {
          editor: "",
          cover: cover4,
          text: "随着社会经济的发展，我国居民的营养状况和健康水平已经明显改善。食物供应和营养保障能力的增强，使人民更容易获得所需的七大营养素:碳水化合物、脂肪、蛋白质、维生素、矿物质、水和膳食纤维，这些养分在维持生命和促进健康中发挥着至关重要的作用。然而，我们仍然面临一系列新的挑战，膳食不平衡已成为慢性疾病的主要危险因素，例如肥胖、糖尿病和心血管疾病等。为了科学评估个体和群体的膳食结构，并提供合理的膳食指导，需要了解每种营养素的作用以及如何在膳食中平衡摄入。这将有助于解决膳食不平衡问题，提高人民的健康水平，同时为食品与营养领域的从业者提供了更多机会和挑战，以提高他们的专业素养和职业能力。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927615409499017216&goodsType=looseleafOrtextbook",
        },
        {
          editor: " ",
          cover: cover5,
          text: "沟通力就是竞争力，在工作和生活中，我们每天都需要沟通，良好的沟通会为个人的交往和发展创造条件。良好的商务沟通会帮助企业在竞争中促进合作、提高决策效率。 本项目分为沟通的目标与类型、有效的商务沟通和商务沟通分析与发展趋势三个基本任务，力求通过任务情境导入、核心知识学习、情景训练、体验活动等，使学习者了解和掌握商务沟通的相关知识，能根据目标制定提高沟通能力的计划，同时建立良好的沟通意识，培养商务沟通的职业素养。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927616237546901504&goodsType=looseleafOrtextbook",
        },
        {
          editor: "",
          cover: cover6,
          text: "中国制造的家电、数码产品席卷韩国市场;中国出海跨境电商平台在欧美进一步崭露头角;义乌圣诞用品、保暖产品等商品出现爆单.2023年“黑色星期五”购物周，海外市场再次刮起了中国风。一件商品从中国发出，只需5天就能送到远在万里之外的消费者手中。从原来的60日送达到10日送达,再到如今的5日送达，跨境电商物流时效不断刷新“最快”记录。政策有力度，企业有底气，使得跨境电商成为推动中国外贸增长、加速企业出海的新发力点。“网购保税进口”“直购进口”“特殊区域出口”“跨境电商出口海外仓”.…近年来，有关部门累计出台各类创新举措近200余项，加快推进综合保税区综合改革，不断推动我国跨境电商全方位提速。截至2023年12月，我国已与29个国家签署双边电子商务合作备忘录，跨境电商海外仓超1500个，总面积超1900万平方米。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927616648521584640&goodsType=looseleafOrtextbook",
        },
        {
          editor: "",
          cover: cover7,
          text: "语言的产生源于人们对它的运用需要，语言也只有在运用中才更能显出它的价值，只有在不断运用中才能更好地完善自身，更好地为人们的生活和学习服务，促进社会的不断发展。言语交际就是语言的一种具体运用，它在人们的社会生活中、在历史的发展中扮演着重要的角色，起着重要的作用。人们总是利用言语交际来实现相互沟通，以达到交际目的，进一步促进和完善自我及群体。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927617139083186176&goodsType=looseleafOrtextbook",
        },
        {
          editor: " ",
          cover: cover8,
          text: "数字经济与物流经济深度融合，网络货运、数字仓库、无人码头、物流机器人等物流新模式、新业态、新技术、新设施设备不断涌现，以高度信息化、数字化、网络化、柔性化、无人化为特征的智慧物流行业发展迅猛。本项目以智慧物流行业为背景，围绕智慧物流服务、物流企业认知、物流岗位设置与职业发展、物流职业素养提升与工匠精神培育四个典型工作任务，通过学习与实践，掌握智慧物流与智慧物流服务的特点，物流企业组织结构形式与企业文化的主要构成，物流核心岗位职责及工作内容，优秀物流人应具备的职业素养与工匠精神培育。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927617499264847872&goodsType=looseleafOrtextbook",
        },
      ],
      // newlist: [
      //   {
      //     editor: "魏卫 崔译文 张云侠 ",
      //     cover: new1,
      //     text: "《旅游市场营销》全新数字化教材，旨在为旅游管理类或其他管理类本专科学生提供一本既符合新时代要求，又具备高度实用性和前瞻性的权威教材。本教材可作为各类本科院校、高等专科职业技术院校及成人教育培训等相关专业的课程用书，也可作为旅游企业和市场营销从业人员的参考读物。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1900447077385768960&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "袁翠翠 ",
      //     cover: new2,
      //     text: "教材结合商业银行业务核算特点，以商业银行的主导业务为主线，围绕基本理论，突出实务训练，在总结教学实践经验并借鉴同行业先进经验的基础上编写而成。本教材在编写过程中始终秉承“以学生为中心”的教学理念，结合课程特点、学时要求和学生实际情况，在每章中都设计了对应的练习题,对教学内容进行了较好的整合。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1869975476336988160&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "李国玉 ",
      //     cover: new3,
      //     text: "Power BI作为一款功能强大的数据分析软件，凭借其高效的数据处理能力和直观的可视化效果，赢得了广泛认可。本书《财务报表分析——Power BI从入门到精通》致力于将财务报表的深厚理论知识与Power BI的数据分析技能相融合，为读者打造一本既具理论深度又富有实践应用的综合性教材。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915236380997455872&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "邢莹莹 王沛炼 邓夏 ",
      //     cover: new4,
      //     text: "本书从翡翠的起源入手，探讨其形成的地质条件和过程，以及其在地球漫长历史中的演变和分布规律，从而揭示翡翠作为大自然瑰宝的奥秘；随后，深入剖析翡翠的宝石学特征，包括其化学成分、晶体结构、物理性质等，为读者奠定坚实的理论基础；接着介绍合成翡翠及翡翠仿制品的最新研究成果，通过对比分析，帮助读者掌握鉴别真伪的关键技术，提高鉴赏能力。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1891691767590424576&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "李园 ",
      //     cover: new5,
      //     text: "本教材旨在为珠宝设计专业的本科生、相关从业人员、珠宝设计爱好者提供系统、实用的软件学习指南，帮助学生掌握JeweICAD的核心功能、建模规范及其在首饰生产加工中的关键作用。全书内容基于笔者多年的教学与实践经验，结合行业标准，力求在技术操作与设计思维之间建立平衡，使读者不仅能熟练运用软件工具，更能理解数字化设计在珠宝产业链中的实际应用。。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1914196857383424000&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "梁文思 ",
      //     cover: new6,
      //     text: "以色彩为研究对象，了解色彩是如何产生、色彩的划分、色彩的基本特征等。从色彩的原理出发，结合人们的认知感受以及实践应用的经验，寻找出色彩变化、搭配和应用的规律，从而能够对艺术设计中的色彩有理性的、全局的认识。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915237830272094208&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "文海",
      //     cover: new7,
      //     text: "本教材没有像其他的书籍那样分别对人物、静物、风景等进行介绍，这是因为珠宝设计和服装与服饰设计专业的学生绘画基础课时间比较少，他们不能像绘画专业的学生那样去全面地学习绘画基础、只能在有限的时间里掌握绘画的技巧，作者摒弃了部分非必要掌握的知识内容，直接从技法入手，详细分析技法的运用及最后的效果。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1914843587703607296&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "郭涛",
      //     cover: new8,
      //     text: "本教材内容由工具、金属材料与参考信息，工艺与示范、作品欣赏三部分组成，其中基础工艺、金属起版工艺、金属表面处理工艺、特殊工艺等以实践示范图例呈现，由浅至深讲解各项工艺,的特点与技艺要求，从设计、工艺流程及成果展示，强调实践操作中的安全意识，帮助学习者建立起从理论到实践、从设计到制造的系统思维、本教材结合代表性的教学案例与商业实践案例、把材料学、宋石学、美学等诸多理论贯穿干各类设计案例中，重点在于引导与开拓学习者的创意性思维能力。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1914192254977839104&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "李岩",
      //     cover: new9,
      //     text: "在艺术与工艺的浩瀚宇宙中，蜡雕以其独特的魅力和深厚的文化底蕴，历经千年而不衰。作为一名投身蜡雕教学十年的教师，我深感荣幸能够见证并参与这一传统技艺的传承与发展。本书的诞生，正是源于这十年教学经验的沉淀与总结，旨在为初学者和爱好者们提供一份系统、实用且富有启发性的蜡雕学习指南。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1916328535266562048&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "荆桦",
      //     cover: new10,
      //     text: "Rhinoceros 8（犀牛 8）是由 McNeel & Associates 公司开发的一款专业 3D 建模软件。它具备丰富多样的建模工具，涵盖了 NURBS 曲线、曲面、实体、细分几何图形（SubD）、点云和多边形网格等，能够让用户顺利构建出从简单到复杂的各类三维模型。其基于 NURBS 技术，在建模精度方面表现卓越，可满足不同复杂程度、阶数以及尺寸大小的模型构建要求，无论是机械零件还是珠宝首饰等对精度要求颇高的设计项目都能精准应对",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915279238211178496&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "江秋仪",
      //     cover: new11,
      //     text: "新能源汽车产业是国家重点发展和大力扶持的产业。由于国家政策的扶持，新能源汽车产业得到飞速的发展，由此带来的新能源汽车后市场将需要大量的销售、维修及其他方面的专业人才。根据目前情况，除了汽车厂家指定的服务站外，综合汽车维修企业接触到的新能源汽车维修业务已经越来越多，汽车维修行业维修技师迫切需要一本体系化的新能源汽车专业书籍，以满足汽车维修技师学习和行业培训的需求。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915294941916041216&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "张春花",
      //     cover: new12,
      //     text: "一本专注于汽车电气系统和电子设备的专业书籍，主要面向汽车工程、车辆工程、电气工程等相关专业的学生、教师以及汽车行业的工程技术人员。该书系统地介绍了现代汽车中各种电器与电子设备的基本原理、结构、功能及其应用，涵盖了从传统汽车电气系统到现代智能汽车电子技术的广泛内容。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915308070452465664&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "马海霞",
      //     cover: new13,
      //     text: "一本专注于反激式开关电源技术的专业书籍，主要面向电力电子、电气工程、自动化等相关领域的学生、研究人员以及从事电源设计与开发的工程技术人员。该书系统地介绍了反激式开关电源的基本原理、设计方法、关键元器件选型、控制策略以及实际应用，涵盖了从基础理论到工程实践的全面内容。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915319766151729152&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "沈剑文 乔世燕 邝曦妮",
      //     cover: new14,
      //     text: "我们认为，“译机融合”是一种翻译操作模式，指的是在翻译过程中，充分发挥机器翻译与人工翻译各自的优势，利用技术手段提升翻译质量、提高翻译效率。“译机融合”强调机器与人工的协同作用，译者首先通过机器处理大量源语言（source language，ST）文本，快速生成目的语（target language，TL）文本初稿，再由人进行细致的编辑和校对，从而实现翻译的准确性和自然性。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1914188486613798912&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "董 艺  胡慧芸  李 虹",
      //     cover: new15,
      //     text: "本书涵盖了机械制图基本理论和软件操作两大部分内容，由基于AutoCAD软件保护的二维图绘制、基于Sloidworks软件的三维建模、基于Sloidworks软件的装配、基于Sloidworks软件的工程图绘制、减速箱的建模与装配等5个项目组成。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915323026329702400&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "王磊 冯慧雅 万慧兰",
      //     cover: new16,
      //     text: "全书包含七个项目，深入浅出地介绍了人工智能技术的整体框架和应用场景，并探讨了人工智能技术、人工智能的实践研究、智能机器人、人工智能伦理等内容。我们在编写本书时考虑了通识性和综合性两方面，在每个项目开篇都给出了相应的导读案例，逐步引出主题内容，力求以技术渗透讲解、以应用实例加深理解。在每个项目末尾设置了习题，帮助读者进一步加深理解。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1913074559070900224&goodsType=looseleafOrtextbook",
      //   },
      //   {
      //     editor: "郝琦 高震 ",
      //     cover: cover9,
      //     text: "CorelDRAW 软件是一款“亲民”的设计软件，由于其运行速度快、操作简便、绘图功能强大，自问世以来就受到设计师们的青睐。",
      //     url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877516845351833600",
      //   },
      // ],
    };
  },
  created() {},
  methods: {
    toDetail(id) {
      if (id) {
        window.open(id, "_blank");
      }
    },
  },
};
</script>
    <style lang='scss' scoped>
.general {
  background-color: #ffffff;
}
.banner {
  margin-bottom: 55px;
}
.title {
  text-align: center;
  margin-bottom: 12px;
  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
  font-weight: 400;
  font-size: 24px;
  color: #2d2d2d;
  line-height: 28px;
  img {
    // width: 180px;
    height: 16px;
  }
}
.container {
  width: 1400px;
  margin: 52px auto 0;
  padding-bottom: 75px;
  .book_list {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .book_item {
      cursor: pointer;
      width: 430px;
      height: 234px;
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 65px;
      position: relative;
      background-color: #fcfcfc;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: calc((100% - 1260px) / 3);
      .back {
        width: 84px;
        height: 88px;
        position: absolute;
        right: 0;
        bottom: 0;
        background: url("../../assets/images/general/item_back.png") no-repeat;
        background-size: 100% 100%;
        opacity: 0.2;
      }

      .text {
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        margin-right: 24px;
        margin-top: -20px;
        width: 203px;
        height: calc(100% - 16px);
        // padding: 8px 0;
        .introduce {
          text-indent: 2em;
          height: calc(100% - 48px);
          overflow-y: auto;
        }
      }
      .white {
        width: 172px;
        height: 231px;
        transform-origin: left bottom;
        // background: url("../../assets/images/general/bg.png");
        background: #ffffff;
        box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);
        position: absolute;
        left: 0px;
        top: -10px;
        transition: transform 0.5s ease-in-out;
        transform: rotateZ(0deg);
        .shadow {
          position: absolute;
          top: 0;
          left: 0;
          width: 172px;
          height: 231px;
          transform-origin: left bottom;
          transition: transform 0.5s ease-in-out;
          background: rgb(180, 176, 176);
          .whites {
            width: 172px;
            height: 231px;
            transform-origin: left bottom;
            transition: transform 0.5s ease-in-out;
            background: #ffffff;
            .title_pic {
              // position: absolute;
              width: 172px;
              height: 231px;
              box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);
              transition: transform 0.5s ease-in-out;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    .book_item:nth-child(3n) {
      margin-right: 0;
    }
    // .book_item {
    //   box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);

    //   .white {
    //     transform-origin: left bottom;
    //     transform: rotateZ(-2deg) translateX(12px);
    //     .shadow {
    //       transform-origin: left bottom;
    //       transform: rotateZ(0deg) translateX(-4px);
    //       .whites {
    //         transform-origin: left bottom;
    //         transform: rotateZ(0deg) translateX(-4px);
    //         .title_pic {
    //           transform-origin: left bottom;
    //           transform: rotateZ(-0deg) translateX(-4px);
    //         }
    //       }
    //     }
    //   }
    // }
  }
}
.nopadding {
  padding-bottom: 0;
}
</style>